import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { ConditionEditComponentModule } from '../../../../condition-edit/condition-edit.module';
import { EditSelectionFieldComponentModule } from '../../../../edit-selection-field/edit-selection-field.module';
import { LoggingComponentModule } from '../../logging/logging.module';
import { ExpressionEditComponentModule } from './expression-edit/expression-edit.module';
import { ExpressionToolComponent } from './expression-tool.component';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    InputTextModule,
    CheckboxModule,
    TooltipModule,
    ReactiveFormsModule,
    ButtonModule,
    EditSelectionFieldComponentModule,
    ConditionEditComponentModule,
    FormsModule,
    MessagesModule,
    ExpressionEditComponentModule,
    TabViewModule,
    LoggingComponentModule,
  ],
  declarations: [ExpressionToolComponent],
  exports: [ExpressionToolComponent],
})
export class ExpressionToolComponentModule {}
